import Translator from '~/presentation/components/i18n/Translator';

export function mapperRoles(role: String): string {
  switch (role) {
    case 'SYSADMIN':
      return Translator('Administrador do Sistema');
    case 'ORG_ADMIN':
      return Translator('Administrador da Organização');
    case 'UNIT_ADMIN':
      return Translator('Organizador do Setor');
    case 'STANDARD':
      return Translator('Usuário Padrão');
    case 'MODERATOR':
      return Translator('Moderador');
    case 'ATTENDEE':
      return Translator('Convidado');
    default:
      return Translator('Error');
  }
}

export function mapperConferenceRoles(role: String): string {
  switch (role) {
    case 'MODERATOR':
      return Translator('Moderador');
    case 'ATTENDEE':
      return Translator('Convidado');
    default:
      return Translator('Convidado');
  }
}
